import { makeStyles } from '@material-ui/styles';
import { DefaultTheme } from '@material-ui/styles';

const useStyles = makeStyles<DefaultTheme>({
    view_horizon_consistency: {
        width: '100%',
        backgroundColor: 'transparent',
        marginBottom: '20px !important',
    },
    view_horizon_consistency_title: {
        backgroundColor: 'transparent',
        marginBottom: '10px !important',
    },
    text_horizon_consistency: {
        fontFamily: 'serca-condensed-text',
        letterSpacing: 1,
        fontSize: 16,
        color: "#000000",
        fontWeight: "bold",
        textAlign: "center"
    },
    view_horizon_consistency_subtitle: {
        flexDirection: 'column',
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    text_horizon_consistency_subtitle: {
        flexDirection: 'row',
        backgroundColor: 'transparent',
        alignItems: 'center',
    },
    view_horizon_consistency_content: {
        width: '100%',
        flexDirection: 'column',
        backgroundColor: 'transparent',
        justifyContent: 'space-around',
    },
    picker_select_type: {
        padding: '10px 20px !important',
        width: '300px',
        display: 'flex',
        justifyContent: 'center',
        borderRadius: 15,
        marginBottom: '10px !important',
        '& fieldset.MuiOutlinedInput-notchedOutline': {
            borderColor: '#06617c !important',
        }
    },
    picker_select_item: {
        color: '#000',
        width: '100%',
        textAlign: 'center',
        fontFamily: 'serca-condensed-text',
        fontSize: 16,
        backgroundColor: 'transparent',
    },
});

export default useStyles;